import DespatchDialog from './DespatchDialog';

export default DespatchDialog ;